import { render } from "./RegionModeratorsList.vue?vue&type=template&id=3118886b&scoped=true"
import script from "./RegionModeratorsList.vue?vue&type=script&lang=js"
export * from "./RegionModeratorsList.vue?vue&type=script&lang=js"

import "./RegionModeratorsList.vue?vue&type=style&index=0&id=3118886b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3118886b"]])

export default __exports__